import { render, staticRenderFns } from "./ServiceStatus.vue?vue&type=template&id=2dc2ae95&scoped=true"
import script from "./ServiceStatus.vue?vue&type=script&lang=js"
export * from "./ServiceStatus.vue?vue&type=script&lang=js"
import style0 from "./ServiceStatus.vue?vue&type=style&index=0&id=2dc2ae95&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dc2ae95",
  null
  
)

export default component.exports